import initial from 'domain/initial';
import DraftApplication from 'domain/types/DraftApplication';
import { Button } from 'react-bootstrap';
import { useForm } from 'react-final-form';
import { ApplicationStep } from '../../../domain/enums/ApplicationStep';

function ClearStep(props: {
  className?: string;
  step: ApplicationStep;
  profileEmail: string;
}) {
  const { change } = useForm<DraftApplication>();

  const handleClear = () => {
    const app = initial.application();
    switch (props.step) {
      case ApplicationStep.review:
        return;
      case ApplicationStep.contact: {
        return change('email', props.profileEmail);
      }
      case ApplicationStep.address: {
        return change('address', initial.address());
      }
      case ApplicationStep.relationship: {
        change('propertyRelaCd', 'NONE');
        change('primaryResIndicator', '');
        change('numberOfRooms', null);
        return;
      }
      case ApplicationStep.details: {
        change('intermediaries', app.intermediaries);
        change('dwellingTypeCd', 'NONE');
        change('howManyRooms', app.howManyRooms);
        return;
      }
    }
  };

  return (
    <Button
      className={props.className}
      type='button'
      variant='link'
      onClick={handleClear}
    >
      Clear step
    </Button>
  );
}

export default ClearStep;
